import clsx from 'clsx';
import Link from 'next/link';
import { Badge, badgeVariants } from '@/shadcn/components/Badge';
import { buttonVariants } from '@/shadcn/components/Button';
import { ChevronRight } from 'lucide-react';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const PublicHero = _ref => {
  let {
    className,
    badge,
    heading,
    subHeading,
    primaryButton,
    secondaryButton
  } = _ref;
  return /*#__PURE__*/_jsxs("section", {
    className: clsx(styles.container, 'relative pt-20 pb-16 sm:py-32 border-b border-gray-200', className),
    children: [/*#__PURE__*/_jsx("div", {
      className: "pointer-events-none absolute -inset-y-20 inset-x-0 bg-[radial-gradient(ellipse_60%_60%_at_65%_50%,hsl(var(--accent))_0%,transparent_80%)]"
    }), /*#__PURE__*/_jsx("div", {
      className: "pointer-events-none absolute -inset-y-20 inset-x-0 bg-[radial-gradient(hsl(var(--accent-foreground)/0.1)_1px,transparent_1px)] [background-size:8px_8px] [mask-image:radial-gradient(ellipse_60%_60%_at_65%_50%,#000_0%,transparent_80%)]"
    }), /*#__PURE__*/_jsx("div", {
      className: "container relative mx-auto px-6",
      children: /*#__PURE__*/_jsxs("div", {
        className: "flex flex-col items-center text-center",
        children: [badge && badge.link && /*#__PURE__*/_jsx(Link, {
          href: badge.link,
          className: badgeVariants({
            variant: 'outline'
          }),
          children: "Badge"
        }), badge && !badge.link && /*#__PURE__*/_jsx(Badge, {
          variant: "outline",
          children: badge.text
        }), /*#__PURE__*/_jsx("h1", {
          className: "my-6 text-pretty text-4xl font-bold lg:text-6xl",
          children: heading
        }), subHeading && /*#__PURE__*/_jsx("p", {
          className: "mb-8 max-w-3xl text-muted-foreground lg:text-xl",
          children: subHeading
        }), (primaryButton || secondaryButton) && /*#__PURE__*/_jsxs("div", {
          className: "flex w-full flex-col justify-start gap-2 sm:flex-row",
          children: [primaryButton && /*#__PURE__*/_jsxs(Link, {
            href: primaryButton.link,
            className: clsx(buttonVariants({
              variant: 'default'
            }), 'w-full sm:w-auto'),
            children: [primaryButton.text, /*#__PURE__*/_jsx(ChevronRight, {
              className: "ml-2 size-4"
            })]
          }), secondaryButton && /*#__PURE__*/_jsx(Link, {
            href: secondaryButton.link,
            className: clsx(buttonVariants({
              variant: 'outline'
            }), 'w-full sm:w-auto'),
            children: secondaryButton.text
          })]
        })]
      })
    })]
  });
};

export default PublicHero;